import { BaseApi } from "../../utils/BaseApi";
import { HttpMethodEnum } from "../models/HttpMethodEnum";
import { OrderModel } from "../models/order/OrderModel";
import {
  TypeDiscountEnum,
  TypePaymentMethodEnum,
} from "../models/order/PaymentModel";

export class OrderApi extends BaseApi {
  private static instance: OrderApi;

  public static get(): OrderApi {
    if (!this.instance) {
      this.instance = new OrderApi();
    }
    return this.instance;
  }

  public getOrCreateOrder = BaseApi.createEndpoint<
    OrderModel,
    { moduleId: string }
  >(HttpMethodEnum.POST, "/orders/getOrCreate");

  public assignCustomer = BaseApi.createEndpoint<
    OrderModel,
    { orderId: string; customerId: string }
  >(HttpMethodEnum.POST, "/orders/customer/assign");

  public addItem = BaseApi.createEndpoint<
    OrderModel,
    {
      orderId: string;
      productId: string;
      quantity: Number;
      moduleId: string;
      comments: string;
    }
  >(HttpMethodEnum.POST, "/orders/item/add");

  public deleteItem = BaseApi.createEndpoint<
    OrderModel,
    {
      itemId: string;
      notes: string;
    }
  >(HttpMethodEnum.POST, "/orders/item/delete");

  public sendToPreparation = BaseApi.createEndpoint<
    OrderModel,
    { orderId: string }
  >(HttpMethodEnum.POST, "/orders/station/send");

  public doneStationOrder = BaseApi.createEndpoint<
    OrderModel,
    { stationOrderId: string }
  >(HttpMethodEnum.POST, "/orders/station/done");

  public payOrder = BaseApi.createEndpoint<
    OrderModel,
    {
      orderId: string;
      cashId: string;
      paymentMethod: TypePaymentMethodEnum;
      moduleId: string;
      discountType: TypeDiscountEnum;
      discountValue: number;
    }
  >(HttpMethodEnum.POST, "/orders/pay");

  public getAllOrdersByDate = BaseApi.createEndpoint<
    OrderModel[],
    { from: string; to: string }
  >(HttpMethodEnum.GET, "/orders/all");
}

export const orderApi = OrderApi.get();
